'use client';

import { FormEvent, useCallback, useEffect, useRef, useState } from 'react';
import { theme } from 'components/theme';
import arrowImage from '../../assets/images/arrow.svg?include';
import { GetStartedButton } from './GetStartedButton';
import { EmailInput } from './EmailInput';
import { isEmailValid } from '../../utils/isEmailValid';
import { useTranslations } from 'next-intl';
import styles from './EmailFormWithAction.module.css';

export const EmailFormWithAction = ({
  className,
  type,
  autoFocusOnDesktop = false,
  callback,
}: {
  className?: string;
  type?: 'solid';
  autoFocusOnDesktop?: boolean;
  callback?: (email: string) => void;
}) => {
  const t = useTranslations('common');
  const inputRef = useRef<HTMLInputElement>(null);
  const [hasError, setError] = useState<boolean>(false);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();

    const target = e.target as any;
    const email = target.email.value;

    if (!isEmailValid(email)) {
      setError(true);
      return;
    }

    setError(false);

    if (typeof callback === 'function') {
      callback(email);
    }
  };

  const handleChange = useCallback(() => {
    setError(false);
  }, []);

  useEffect(() => {
    if (
      window.innerWidth >
        parseInt(theme.global.tablet.maxWidth.replace('px', '')) &&
      autoFocusOnDesktop
    ) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <form
      className={[styles.root, className].filter(Boolean).join(' ')}
      onSubmit={onSubmit}
    >
      <div data-variant={type}>
        <EmailInput
          onChange={handleChange}
          hasError={hasError}
          placeholder={t('emailFormWithAction.emailInput.placeholder.yourEmail')}
          name="email"
          styleType={type}
          type="email"
          aria-label={t(
            'emailFormWithAction.emailInput.ariaLabel.enterYourEmail',
          )}
          ref={inputRef}
        />
        <GetStartedButton aspect={type}>
          <span>
            {t('emailFormWithAction.text.getAccess')}
            <span dangerouslySetInnerHTML={{ __html: arrowImage.src }} />
          </span>
        </GetStartedButton>
      </div>
    </form>
  );
};
